var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.93932 4.93934C5.52511 4.35355 6.47486 4.35355 7.06064 4.93934L14.121 11.9997L7.06069 19.0606C6.47493 19.6464 5.52519 19.6465 4.93937 19.0607C4.35356 18.475 4.35351 17.5252 4.93927 16.9394L9.87842 11.9998L4.93932 7.06066C4.35354 6.47487 4.35354 5.52513 4.93932 4.93934Z",
    fill: "#D1D5DC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.0814 4.93934C18.4956 4.35355 17.5459 4.35355 16.9601 4.93934L9.89979 11.9997L16.9601 19.0606C17.5458 19.6464 18.4956 19.6465 19.0814 19.0607C19.6672 18.475 19.6672 17.5252 19.0815 16.9394L14.1423 11.9998L19.0814 7.06066C19.6672 6.47487 19.6672 5.52513 19.0814 4.93934Z",
    fill: "#D1D5DC"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.caf6ea194278963c2d2488f75da78d16.svg";
export { ForwardRef as ReactComponent };